import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
// Extends
import PromptUpdaterMixin from '@/helpers/vue_mixins/v3/PromptUpdaterMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
import ActionButton from '@/components/action_button/Index.vue';
import { PromptAction } from '@/helpers/entities/enums/v3/PromptAction';
// Queries / Mutations
/**
 * Prompt Result modal
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.23.0}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1856110808/Modals+Prompt+Result
 */
let PromptResult = class PromptResult extends Mixins(ViewportSizeMixin, PromptUpdaterMixin) {
    constructor() {
        super(...arguments);
        this.regenerateInProgress = false;
    }
    onDoneRegeneratingChanged() {
        if (this.doneRegenerating) {
            this.regenerateInProgress = false;
        }
    }
    async onUpdate(action) {
        await this.updateAction(this.promptUuid, action);
        if (action === PromptAction.accept) {
            this.$emit('promptAccepted');
        }
        else if (action === PromptAction.regenerate) {
            this.regenerateInProgress = true;
            this.$emit('promptRegenerated');
        }
    }
};
__decorate([
    Prop({ type: String, default: 'Title' })
], PromptResult.prototype, "title", void 0);
__decorate([
    Prop({ type: String, default: null })
], PromptResult.prototype, "content", void 0);
__decorate([
    Prop({ type: String, default: null })
], PromptResult.prototype, "reason", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PromptResult.prototype, "promptUuid", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], PromptResult.prototype, "doneRegenerating", void 0);
__decorate([
    Watch('doneRegenerating')
], PromptResult.prototype, "onDoneRegeneratingChanged", null);
PromptResult = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], PromptResult);
export default PromptResult;
